import { createRouter, createWebHistory } from 'vue-router'

import About from './views/about'
import Customerstories from './views/customerstories'
import Solutions from './views/solutions'
import Product from './views/product'
import Resellers from './views/resellers'
import Contactdemo from './views/contactdemo'
import Pricing from './views/pricing'
import Home from './views/home'
import Integrations from './views/integrations'
import NotFound from './views/not-found'
import Terms from './components/terms'
import Policy from './components/policy'
import './style.css'

// Vue 3 migration: vue-router v4 uses createRouter/createWebHistory.
export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      name: 'About',
      path: '/about',
      component: About,
    },
    {
      name: 'Customerstories',
      path: '/customerstories',
      component: Customerstories,
    },
    {
      name: 'Solutions',
      path: '/solutions',
      component: Solutions,
    },
    {
      name: 'Product',
      path: '/product',
      component: Product,
    },
    {
      name: 'Resellers',
      path: '/resellers',
      component: Resellers,
    },
    {
      name: 'Contactdemo',
      path: '/contactdemo',
      component: Contactdemo,
    },
    {
      name: 'Pricing',
      path: '/pricing',
      component: Pricing,
    },
    {
      name: 'Terms',
      path: '/terms',
      component: Terms,
    },
    {
      name: 'Policy',
      path: '/policy',
      component: Policy,
    },
    {
      name: 'Home',
      path: '/',
      component: Home,
    },
    {
      name: 'Integrations',
      path: '/integrations',
      component: Integrations,
    },
    {
      name: '404 - Not Found',
      path: '/:pathMatch(.*)*',
      component: NotFound,
    },
  ],
})
